export default {
  message: {
    cart: "购物车",
    home: "首页",
    discountText: "所有优惠商品高达60%",
    headingTitle: "新产品",
    addToCart: "加入购物车",
    price: "价格",
    rate: "评分",
    TotalPrice: "总价",
    goodNum: "数量",
    buyNow: "立即购买",
    addCart: "加入购物车",
    productDetailTitle: "商品详情",
    productRecommendationsTitle: "商品推荐",
    categoryTitle: "商品分类",
    hotgoodstitle: "热销商品",
    smallDetails: "本商品热门销售中",
    orderSale: "已售",
    msgLanguage: "加入成功",

    sort: "分类",
    clear: "清空",
    dialogTitle: "填写收货地址",
    
    dialogGivenName: "收货人姓",
    dialogSurname: "收货人名",
    dialogPhone: "电话号码",
    dialogEmail: "邮箱",
    dialogPostalCode: "邮政编码",
    dialogAdminArea1: "省份/州",
    dialogAdminArea2: "城市/城镇/村",
    dialogAddressLine1: "街道/门牌号",
    dialogAddressLine2: "套房/公寓号码",
    dialogDescription:'商品描述',
    dialogValue:'价格',

    errorTips:'链接没有填写，请重新结算',
    errorTips2:'请先选择语言',
    errorTips3:'版本号获取失败，请重新结算',
    notProductTitle:"暂无标题",

    /*旧版*/ 
    dialogGivenName: "收货人姓",
    dialogSurname: "收货人名",
    dialogPhone: "电话号码",
    dialogEmail: "邮箱",
    dialogPostalCode: "邮政编码",
    dialogAdminArea1: "省份/州",
    dialogAdminArea2: "城市/城镇/村",
    dialogAddressLine1: "街道/门牌号",
    dialogAddressLine2: "套房/公寓号码",
    /*旧版*/ 

    dialogPay: "前往支付",
    dialogClose: "关闭",
    delete: "删除",
    formTips: "请输入",
    selectPlaceholder: "请选择",
    cartEmpty: "购物车为空",
    detailSize: "尺码",

    buyItNow: "现在就买",
    shipping: "航运",
    pay: "付款",
    back: "退回",
    support: "支持",
    shippingDesc: "来自我精心挑选的卖家",
    checkOut: "结账",
    viewCart: "查看购物车",
    agreePrivacy: "我同意隐私政策",
    remove: "刪除",
    total: "总计",
    language: "语言",
    
    dialogPayErrorTip4: "请输入正确的邮箱地址",// 请输入正确的邮箱地址

    aboutUsText: "关于我们",
    // YouRui网站的
    aboutUsContent: `<div class="product__tab--content__step">
      <h2 class="product__tab--content__title">关于我们</h2>
        <p>優睿貿易有限公司是一家集研发、设计、生产、营销、推广于一体的服装企业。以时尚、活力、知性、优雅为主流设计风格，坚持从精致女性的需求出发，无论设计、选料、剪裁及每一处的细节都保持一定高度，让有内涵有格调有灵性的轻经典风格触手可及。</p>
        <p>致力于将生活、艺术、时尚、文化、个性融合，为消费者提供高品质的时尚生活体验。始终把客户的利益放在第一位，竭诚为我们的每一个客户提供最好产品和最优质的服务。</p>
     </div>`,

    // ZhuoYu网站的
    // aboutUsContent: `<div class="product__tab--content__step">
    // <h2 class="product__tab--content__title">关于我们</h2>
    //   <p>卓裕貿易有限公司是一家集品牌推广、产品开发制造，销售服务。公司拥有着优秀的营销队伍和国内各区域渠道合作伙伴，对于产品的市场开拓和产品售后服务等方面有着健全的管理方案。</p>
    //   <p>销售网络和产品销售代理机构遍布全国，同时我们将一如既往地禀承“信誉第一、客户至上”的原则，始终把客户的利益放在第一位，竭诚为我们的每一个客户提供最好产品和最优质的服务。</p>
    // </div>`,

    contactUsText: "联系我们",
    // YouRui网站的
    contactUsContent: `<div class="product__tab--content__step">
    <h2 class="product__tab--content__title">联系我们</h2>
      <p>营业时间：每周上午 10 点至下午 6 点</p>
      <p>电子邮件：chloeannfountain691@gmail.com（国际邮箱暂时没有）</p>
      <p style="text-indent: 4em;">公司：優睿貿易有限公司Yourui Trading Limited</p>
      <p style="text-indent: 3.2em;">kakao：akmalldjcod</p>
      <p style="text-indent: 4em;">地址：FLAT/RM B 5/F GAYLORD COMMERCIAL BUILDING 114-118 LOCKHART ROAD HK</p>
    </div>`,

    // ZhuoYu网站的
    // contactUsContent: `<div class="product__tab--content__step">
    // <h2 class="product__tab--content__title">联系我们</h2>
    //   <p>营业时间：每周上午 10 点至下午 6 点</p>
    //   <p>电子邮件：zhuoyu202403@gmail.com</p>
    //   <p style="text-indent: 4em;">公司：卓裕貿易有限公司Zhuoyu Trade Limited</p>
    //   <p style="text-indent: 4em;">地址：FLAT/RM 917A BLK A 9/F NEW MANDARIN PLAZA NO 14 SCIENCE MUSELM RD TST HONG KONG</p>
    // </div>`,

    refundsText: "退货与换货",
    refundsContent: `<div class="product__tab--content__step">
      <h2 class="product__tab--content__title">退货与换货</h2>
      <p>客户有权在收到产品后15天内申请退货</p>
      <p>要获得退货资格，您的物品必须未使用并且处于与您收到时相同的状态。它还必须在原始包装中。</p>
      <p>为完成您的退货，我们需要收据或购买证明。</p>
      <p>请不要将您购买的产品退回给制造商。</p>
      <p>退款（如适用）</p>
      <p>收到并检查您的退货后，我们将向您发送一封电子邮件，通知您我们已收到您退回的物品。我们还将通知您退款的批准或拒绝。</p>
      <p>如果您获得批准，则将处理您的退款，并在一定天数内自动将信用额度应用到您的信用卡或原始付款方式。</p>
      <p>延迟或丢失退款（如果适用）</p>
      <p>如果您还没有收到退款，请先再次检查您的银行账户。</p>
      <p>然后联系您的信用卡公司，您的退款可能需要一些时间才能正式发布。</p>
      <p>接下来联系您的银行。在发布退款之前通常需要一些处理时间。</p>
      <p>如果您已完成所有这些操作，但仍未收到退款，请联系我们。</p>
      <p>销售项目（如适用）</p>
      <p>只有正价商品可以退款，很遗憾，促销商品无法退款。</p>
      <p>交易所（如适用）</p>
      <p>我们只更换有缺陷或损坏的物品。如果您需要更换相同的商品，请给我们发送电子邮件，我们将为您提供退货地址。</p>
      <p>礼物</p>
      <p>如果该商品在购买并直接运送给您时被标记为礼物，您将收到相当于退货价值的礼品积分。收到退回的物品后，将向您邮寄礼券。</p>
      <p>如果该商品在购买时未标记为礼物，或者送礼人将订单商品寄给了他们自己稍后再送给您，我们将向送礼人退款，他会知道您的退货情况。</p>
      <p>船运</p>
      <p>要退回您的产品，您应该先邮寄给我们以获取详细信息</p>
      <p>退款政策：</p>
      <p>退款需扣除相关手续费</p>
    </div>`,
    privacyText: "隐私政策",
    privacyContent: `
      <div class="product__tab--content__step">
        <h2 class="product__tab--content__title">隐私政策</h2>
        <p>我们如何处理您的信息？</p>
        <p>当您从我们的商店购买商品时，作为买卖过程的一部分，我们会收集您提供给我们的个人信息，例如您的姓名、地址和电子邮件地址。</p>
        <p>当您浏览我们的商店时，我们还会自动接收您计算机的互联网协议 (IP) 地址，以便向我们提供有助于我们了解您的浏览器和操作系统的信息。 (IP) 地址，以便向我們提供有助於我們瞭解您的流覽器和操作系統的資訊。</p>
        <p>电子邮件营销（如果适用）：在您允许的情况下，我们可能会向您发送有关我们商店、新产品和其他更新的电子邮件。</p>
        <p>隐私与安全</p>
        <p>作为我们常规业务过程的一部分，我们不会向任何人或任何公司出售、交易或出租个人身份信息。但您也应妥善保管您的账户信息，不得将账户信息泄露给他人。</p>
        <p>我如何退订？</p>
        <p>您可以使用任何电子邮件通讯底部的链接取消订阅，或在您的网站用户账户页面中更改您的订阅设置。</p>
        <p>联系我们</p>
        <p>如果您对本隐私政策或我们对您的信息的处理有任何疑问、意见或要求，请随时与我们联系。</p>
        
      </div>
    `,
    shippingText: "船运",
    shippingContent: `<div class="product__tab--content__step ">
      <h2 class="product__tab--content__title">船运</h2>
      <p>总交货时间 = 处理时间 + 运输时间</p>
      <p>客户最多只需要支付一次运费（包括退货）；退货不向消费者收取退货费用。</p>
      <p>处理时间：在发货前，我们会进行质量控制检查和测试，以确保产品在发货前的质量。通常2-7 个工作日。但是，它也会受到商品库存状态的影响。对于存在库存问题的热门商品，处理时间可能为 2-9 个工作日。</p>
      <p>我们是海外网站，国际物流</p>
    </div>`,
    termsText: "条款和条件",
    termsContent: `<div class="product__tab--content__step">
    <h2 class="product__tab--content__title">条款和条件</h2>
    <strong class="h5">概述</strong>
    <p>我们提供本网站，包括本网站向您（用户）提供的所有信息、工具和服务，前提是您接受此处所述的所有条款、条件、政策和通知。</p>
    <p>通过访问我们的网站和/或从我们这里购买东西，您参与我们的“服务”并同意受以下条款和条件（“服务条款”、“条款”）的约束，包括这些附加条款和条件以及政策此处引用和/或可通过超链接获得。这些服务条款适用于网站的所有用户，包括但不限于作为浏览器、供应商、客户、商家和/或内容贡献者的用户。</p>
    <p>在访问或使用我们的网站之前，请仔细阅读这些服务条款。通过访问或使用网站的任何部分，您同意受这些服务条款的约束。如果您不同意本协议的所有条款和条件，则您不得访问网站或使用任何服务。如果这些服务条款被视为要约，则接受明确限于这些服务条款。</p>
    <p>添加到當前商店的任何新功能或工具也應遵守服務條款。您可以隨時在此頁面上查看最新版本的服務條款。我們保留通過在我們的網站上發佈更新和/添加到当前商店的任何新功能或工具也应遵守服务条款。您可以随时在此页面上查看最新版本的服务条款。我们保留通过在我们的网站上发布更新和/或更改来更新、更改或替换这些服务条款的任何部分的权利。您有责任定期检查此页面以了解更改。您在发布任何更改后继续使用或访问网站即表示您接受这些更改。</p>
    <p>我们的商店托管在 Shopify Inc. 他们为我们提供在线电子商务平台，使我们能够向您销售我们的产品和服务。</p>
    <ol>
      <li>
        <h5>1.在线商店条款</h5>
        <p>同意这些服务条款，即表示您至少已达到您所在州或居住省的成年年龄，或者您已达到您所在州或居住省的成年年龄，并且您已同意我们允许您的任何未成年家属使用本网站。</p>
        <p>您不得将我们的产品用于任何非法或未经授权的目的，也不得在使用服务时违反您所在司法管辖区的任何法律（包括但不限于版权法）。您不得传播任何蠕虫或病毒或任何具有破坏性的代码。</p>
        <p>违反或违反任何条款将导致您的服务立即终止。</p>
      </li>
      <li>
        <h5>2.一般条件</h5>
        <p>我们保留随时以任何理由拒绝向任何人提供服务的权利。</p>
        <p>您了解您的内容（不包括信用卡信息）可能会在未加密的情况下传输并涉及 (a) 通过各种网络传输；(b) 更改以符合和适应连接网络或设备的技术要求。信用卡信息在通过网络传输期间始终是加密的。 (a) 通過各種網路傳輸；(b) 更改以符合和適應連接網路或設備的技術要求。信用卡資訊在通過網路傳輸期間始終是加密的。</p>
        <p>未经我们明确书面许可，您同意不复制、复制、复制、出售、转售或利用服务的任何部分、服务的使用、服务的访问或提供服务的网站上的任何联系方式.</p>
        <p>本协议中使用的标题仅为方便起见，不会限制或以其他方式影响这些条款。</p>
      </li>
      <li>
        <h5>3.信息的准确性、完整性和及时性</h5>
        <p>如果本网站提供的信息不准确、不完整或不最新，我们概不负责。本网站上的材料仅供一般参考，在未咨询主要、更准确、更完整或更及时的信息来源的情况下，不应依赖或用作决策的唯一依据。任何对本网站材料的依赖均由您自行承担风险。</p>
        <p>本网站可能包含某些历史信息。历史信息不一定是最新的，仅供您参考。我们保留随时修改本网站内容的权利，但我们没有义务更新我们网站上的任何信息。您同意您有责任监控我们网站的变化。</p>
      </li>
      <li>
        <h5>4.服务和价格的修改</h5>
        <p>我们产品的价格如有更改，恕不另行通知。</p>
        <p>我们保留随时修改或终止服务（或其任何部分或内容）的权利，恕不另行通知。</p>
        <p>对于本服务的任何修改、价格变动、暂停或中止，我们不对您或任何第三方承担任何责任。</p>
      </li>
      <li>
        <h5>5.产品或服务（如果适用）</h5>
        <p>某些产品或服务可能仅通过网站在线提供。这些产品或服务可能数量有限，只能根据我们的退货政策进行退货或换货。</p>
        <p>我们已尽一切努力尽可能准确地展示出现在商店中的产品的颜色和图像。我们无法保证您的计算机显示器显示的任何颜色都是准确的。</p>
        <p>我们保留权利，但没有义务将我们的产品或服务的销售限制在任何人、地理区域或司法管辖区。我们可以根据具体情况行使此权利。我们保留限制我们提供的任何产品或服务数量的权利。所有产品描述或产品定价可随时更改，恕不另行通知，由我们自行决定。我们保留随时停止任何产品的权利。在本网站上提供的任何产品或服务的任何报价在被禁止的情况下均无效。</p>
        <p>我们不保证您购买或获得的任何产品、服务、信息或其他材料的质量将满足您的期望，或者服务中的任何错误将得到纠正。</p>
      </li>
      <li>
        <h5>6.账单和账户信息的准确性</h5>
        <p>我们保留拒绝您向我们下的任何订单的权利。我们可以自行决定限制或取消每人、每户或每笔订单的购买数量。这些限制可能包括由同一客户账户、同一信用卡和/或使用相同账单和/或送货地址的订单或在同一客户账户下的订单。如果我们更改或取消订单，我们可能会尝试通过联系您在下订单时提供的电子邮件和/或账单地址/电话号码来通知您。我们保留限制或禁止根据我们的判断似乎是由经销商、转售商或分销商下达的订单的权利。/或使用相同帳單和/或送貨地址的訂單或在同一客戶帳戶下的訂單。如果我們更改或取消訂單，我們可能會嘗試通過聯繫您在下訂單時提供的電子郵件和/或帳單地址/電話號碼來通知您。我們保留限制或禁止根據我們的判斷似乎是由經銷商、轉售商或分銷商下達的訂單的權利。</p>
        <p>您同意为在我们商店进行的所有购买提供最新、完整和准确的购买和账户信息。您同意及时更新您的账户和其他信息，包括您的电子邮件地址和信用卡号码以及到期日期，以便我们可以完成您的交易并在需要时与您联系。</p>
        <p>有关更多详细信息，请查看我们的退货政策</p>
      </li>
      <li>
        <h5>7.可选工具</h5>
        <p>我们可能会为您提供对第三方工具的访问权限，我们既不对其进行监控，也不对其进行任何控制或输入。</p>
        <p>您承认并同意，我们“按原样”和“可用”提供对此类工具的访问，没有任何类型的保证、陈述或条件，也没有任何背书。对于因您使用可选的第三方工具而产生的或与之相关的任何责任，我们概不负责。</p>
        <p>您对通过网站提供的可选工具的任何使用完全由您自行承担风险和自行决定，您应确保您熟悉并批准相关第三方提供商提供工具的条款。</p>
        <p>将来，我们还可能通过网站提供新服务和/或功能（包括发布新工具和资源）。此类新功能和/或服务也应遵守这些服务条款。</p>
      </li>
      <li>
        <h5>8.第三方链接</h5>
        <p>通过我们的服务提供的某些内容、产品和服务可能包括来自第三方的材料。</p>
        <p>本网站上的第三方链接可能会将您定向到与我们无关的第三方网站。我们不负责检查或评估内容或准确性，我们不保证也不会对任何第三方材料或网站或第三方的任何其他材料、产品或服务承担任何责任或义务。</p>
        <p>对于与购买或使用商品、服务、资源、内容或与任何第三方网站相关的任何其他交易相关的任何伤害或损害，我们概不负责。请仔细阅读第三方的政策和做法，并确保您在进行任何交易之前了解它们。有关第三方产品的投诉、索赔、疑虑或问题应直接向第三方提出。</p>
      </li>
      <li>
        <h5>9.用户评论、反馈和其他意见</h5>
        <p>如果应我们的要求，您发送了某些特定的提交（例如参赛作品），或者在我们没有要求的情况下，您发送了创意、建议、建议、计划或其他材料，无论是在线、通过电子邮件、邮寄还是其他方式（统称为“评论”），您同意我们可以随时不受限制地编辑、复制、发布、分发、翻译和以其他方式在任何媒体中使用您转发给我们的任何评论。我们没有义务 (1) 对任何评论保密；(2) 对任何评论进行补偿；(3) 回应任何评论。 (1) 對任何評論保密；(2) 對任何評論進行補償；(3) 回應任何評論。</p>
        <p>我们可能但没有义务监控、编辑或删除我们自行决定确定为非法、冒犯、威胁、诽谤、诽谤、色情、淫秽或其他令人反感或违反任何一方的知识产权或本服务条款的内容..</p>
        <p>您同意您的评论不会侵犯任何第三方的任何权利，包括版权、商标、隐私、人格或其他个人或所有权。您进一步同意，您的评论不会包含诽谤或其他非法、辱骂或淫秽材料，或包含可能以任何方式影响服务或任何相关网站运行的任何计算机病毒或其他恶意软件。您不得使用虚假的电子邮件地址，假装不是您自己，或以其他方式误导我们或第三方关于任何评论的来源。您对您发表的任何评论及其准确性承担全部责任。对于您或任何第三方发布的任何评论，我们不承担任何责任。</p>
      </li>
      <li>
        <h5>10.个人信息</h5>
        <p>您通过商店提交的个人信息受我们的隐私政策约束。查看我们的隐私政策</p>
      </li>
      <li>
        <h5>11.错误、不准确和遗漏</h5>
        <p>有时，我们网站或服务中的信息可能包含与产品描述、定价、促销、优惠、产品运费、运输时间和可用性相关的印刷错误、不准确或遗漏。如果服务或任何相关网站上的任何信息不准确，我们保留随时更正任何错误、不准确或遗漏以及更改或更新信息或取消订单的权利，恕不另行通知（包括在您提交订单后）</p>
        <p>我们没有义务更新、修改或澄清服务或任何相关网站上的信息，包括但不限于定价信息，法律要求的除外。服务或任何相关网站上未应用指定的更新或刷新日期，应视为表明服务或任何相关网站上的所有信息均已修改或更新。</p>
      </li>
      <li>
        <h5>12.禁止使用</h5>
        <p>除了服务条款中规定的其他禁令外，您不得使用本网站或其内容：(a) 用于任何非法目的；(b) 招揽他人进行或参与任何非法行为；(c) 违反任何国际、联邦、省或州的法规、规则、法律或地方条例；(d) 侵犯或违反我们的知识产权或他人的知识产权；(e) 基于性别、性取向、宗教、种族、种族、年龄、国籍或残疾进行骚扰、辱骂、侮辱、伤害、诽谤、诽谤、贬低、恐吓或歧视；(f) 提交虚假或误导性信息；(g) 上传或传播病毒或任何其他类型的恶意代码，这些代码将或可能以任何方式使用，影响服务或任何相关网站、其他网站或互联网的功能或操作；(h) 收集或追踪他人的个人信息；(i) 垃圾邮件、网络钓鱼、医药、借口、蜘蛛、爬网或抓取；(j) 出于任何淫秽或不道德的目的；(k) 干扰或规避服务或任何相关网站、其他网站或互联网的安全功能。我们保留终止您违反任何禁止使用的服务或任何相关网站的权利。(j) 出于任何淫秽或不道德的目的；(k) 干扰或规避服务或任何相关网站、其他网站或互联网的安全功能。我们保留终止您违反任何禁止使用的服务或任何相关网站的权利。(j) 出于任何淫秽或不道德的目的；(k) 干扰或规避服务或任何相关网站、其他网站或互联网的安全功能。我们保留终止您违反任何禁止使用的服务或任何相关网站的权利。</p>
      </li>
      <li>
        <h5>13.免责声明；责任限制</h5>
        <p>我们不保证、陈述或保证您对我们服务的使用不会中断、及时、安全或无错误。</p>
        <p>我们不保证使用服务可能获得的结果是准确或可靠的。</p>
        <p>您同意我们可以不时地无限期地删除服务或随时取消服务，恕不另行通知。</p>
        <p>您明确同意您自行承担使用或无法使用该服务的风险。服务以及通过服务交付给您的所有产品和服务（除非我们明确声明）“按原样”和“可用”提供给您使用，没有任何明示或明示的任何形式的陈述、保证或条件暗示的，包括所有关于适销性、适销质量、特定用途的适用性、耐用性、所有权和非侵权的默示保证或条件。</p>
        <p>在任何情况下，我们的董事、高级职员、员工、附属公司、代理人、承包商、实习生、供应商、服务提供商或许可人均不对任何伤害、损失、索赔或任何直接、间接、附带、惩罚性、特殊或后果性损害负责任何类型的损失，包括但不限于因您使用任何服务或使用服务获得的任何产品，或以任何方式与您使用服务或任何产品相关的任何其他索赔，包括但不限于任何内容的任何错误或遗漏，或任何损失或由于使用服务或发布、传输的任何内容（或产品）而导致的任何类型的损害，或以其他方式通过服务提供，即使已被告知其可能性。</p>
        <p>由于某些州或司法管辖区不允许排除或限制间接或附带损害的责任，因此在这些州或司法管辖区，我们的责任应限于法律允许的最大范围内。</p>
      </li>
      <li>
        <h5>14.赔偿</h5>
        <p>您同意对我们公司和我们的母公司、子公司、附属公司、合作伙伴、管理人员、董事、代理人、承包商、许可人、服务提供商、分包商、供应商、实习生和员工进行赔偿、辩护并使其免受任何索赔或要求的损害，包括合理的任何第三方因您违反这些服务条款或它们通过引用合并的档，或您违反任何法律或第三方的权利而产生的律师费。</p>
      </li>
      <li>
        <h5>15.可分割性</h5>
        <p>如果本服务条款的任何条款被确定为非法、无效或不可执行，则该条款仍应在适用法律允许的最大范围内可执行，不可执行部分应视为与本条款分离服务，此类决定不应影响任何其他剩余条款的有效性和可执行性。</p>
      </li>
      <li>
        <h5>16.终止</h5>
        <p>就所有目的而言，双方在终止日期之前产生的义务和责任应在本协议终止后继续有效。</p>
        <p>这些服务条款在您或我们终止之前有效。您可以随时通过通知我们您不再希望使用我们的服务或停止使用我们的网站来终止这些服务条款。</p>
        <p>如果我们单方面判断您未能或我们怀疑您未能遵守本服务条款的任何条款或规定，我们也可以随时终止本协议，恕不另行通知，您仍将对所有到期款项负责至并包括终止日期；和/或因此可能拒绝您访问我们的服务（或其任何部分）。/或因此可能拒絕您訪問我們的服務（或其任何部分）。</p>
      </li>
      <li>
        <h5>17.完整协议</h5>
        <p>我们未能行使或执行本服务条款的任何权利或规定，并不构成对该权利或规定的放弃。</p>
        <p>这些服务条款以及我们在本网站上发布的或与服务相关的任何政策或操作规则构成您与我们之间的完整协议和谅解，并约束您对服务的使用，取代任何先前或同期的协议、通讯和建议，无论是口头还是书面，您和我们之间（包括但不限于服务条款的任何先前版本）。</p>
        <p>对本服务条款的解释如有歧义，不得对起草方作出不利解释。</p>
      </li>
      <li>
        <h5>18.服务条款的变更</h5>
        <p>您可以随时在此页面查看最新版本的服务条款。</p>
        <p>我们保留自行决定通过在我们的网站上发布更新和更改来更新、更改或替换这些服务条款的任何部分的权利。您有责任定期查看我们的网站以了解更改。在发布对这些服务条款的任何更改后，您继续使用或访问我们的网站或服务即表示您接受这些更改</p>
      </li>
      <li>
        <h5>19.适用法律</h5>
        <p>这些服务条款以及我们向您提供服务所依据的任何单独协议均应受当地法律管辖并根据当地法律进行解释。</p>
      </li>
    </ol>
  </div>`,
  },
  // 商品列表
  // productList: [
  //   {
  //     id: 1,
  //     imgUrl: "pro1-1.jpg",
  //     title: "SASAVIN蛋白棒",
  //     singlePrice: 393.25,
  //     bigProduct:['pro1-2.png','pro1-3.png']
  //   },
  //   {
  //     id: 2,
  //     imgUrl: "pro2-1.jpg",
  //     title: "朵匠、优姿轻解素、益生元多肽片压片糖果",
  //     singlePrice: 536.25,
  //     bigProduct:['pro2-2.jpg','pro2-3.jpg']

  //   },
  //   {
  //     id: 3,
  //     imgUrl: "pro3-1.jpg",
  //     title: "亨德仁源堂油切分解素双菇多肽粉固体饮料",
  //     singlePrice: 343.2,
  //     bigProduct:['pro3-2.jpg','pro3-3.jpg']

  //   },
  //   {
  //     id: 4,
  //     imgUrl: "pro4-1.jpg",
  //     title: "极魅曲然堂、低脂高纤型代餐营养粉",
  //     singlePrice: 493.35,
  //     bigProduct:['pro4-2.jpg','pro4-3.jpg']

  //   },
  //   {
  //     id: 5,
  //     imgUrl: "pro5-1.jpg",
  //     title: "蓝莓复合益生元固体饮料",
  //     singlePrice: 550.55,
  //     bigProduct:['pro5-2.jpg','pro5-3.jpg']

  //   },
  //   {
  //     id: 6,
  //     imgUrl: "pro6-1.jpg",
  //     title: "诺丽果低聚果糖压片",
  //     singlePrice: 536.25,
  //     bigProduct:['pro6-2.png','pro6-3.png']

  //   },
  //   {
  //     id: 7,
  //     imgUrl: "pro7-1.jpg",
  //     title: "奇亚籽固体饮料",
  //     singlePrice: 536.25,
  //     bigProduct:['pro7-2.jpg','pro7-3.jpg']

  //   },
  //   {
  //     id: 8,
  //     imgUrl: "pro8-1.jpg",
  //     title: "轻姿溶解素",
  //     singlePrice: 1079.65,
  //     bigProduct:['pro8-2.jpg','pro8-3.jpg']

  //   },
  //   {
  //     id: 9,
  //     imgUrl: "pro9-1.jpg",
  //     title: "神奇粉末，固体饮料",
  //     singlePrice: 328.9,
  //     bigProduct:['pro9-2.jpg','pro9-3.png']

  //   },
  //   {
  //     id: 10,
  //     imgUrl: "pro10-1.jpg",
  //     title: "神奇粉末益生菌果蔬植物酵素粉",
  //     singlePrice: 536.25,
  //     bigProduct:['pro10-2.jpg','pro10-3.png']

  //   },
  //   {
  //     id: 11,
  //     imgUrl: "pro11-1.jpg",
  //     title: "新活力因子",
  //     singlePrice: 371.8,
  //     bigProduct:['pro11-2.png','pro11-3.jpg','pro11-4.jpg']

  //   },
  //   {
  //     id: 12,
  //     imgUrl: "pro12-1.jpg",
  //     title: "新--芊润易简玫奇亚籽固体饮料",
  //     singlePrice: 536.25,
  //     bigProduct:['pro12-2.png','pro12-3.png']

  //   },
  //   {
  //     id: 13,
  //     imgUrl: "pro13-1.jpg",
  //     title: "伊美源、轻轻果冻果味型果冻",
  //     singlePrice: 536.25,
  //     bigProduct:['pro13-2.jpg','pro13-3.jpg']

  //   },
  //   {
  //     id: 14,
  //     imgUrl: "pro14-1.jpg",
  //     title: "植物三调茶",
  //     singlePrice: 536.25,
  //     bigProduct:['pro14-2.jpg','pro14-3.png','pro14-4.png']

  //   },
  //   {
  //     id: 15,
  //     imgUrl: "pro15-1_zh.jpg",
  //     title: "补差价",
  //     singlePrice: 1,
  //   },
  // ],
  productList: [],
  cartList: [],
  retail: {
    id: 15,
    imgUrl: "pro15-1_zh.jpg",
    title: "补差价",
    singlePrice: 1,
    isRetail: true,
  },
};
